import { Box, FormControl, Typography } from "@mui/material";
import { DatePicker, TimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useState } from "react";
import { s360ConfigService } from "../../Services/S360Config";

function NCXFormDate(props) {
    const [localValue, setLocalValue] = useState(null)
    const fieldname = props?.field?.properties?.fieldname;

    const fieldChangeHandle = (newValue) => {
        setLocalValue(newValue)
        props?.handleInputChange(fieldname, newValue, props?.field)
    }

    const primaryFontColorSelectorFromConfig = s360ConfigService.config?.configDetails?.primaryColor ?? "#000";
    const primaryColorSelectorFromConfig = s360ConfigService.config?.configDetails?.primaryFontColor ?? "#fff";

    const getThemedSlotProps = () => {
        return {
            tabs: {
                sx: {
                    "& .MuiTab-textColorPrimary.Mui-selected": {
                        color: `${primaryFontColorSelectorFromConfig} !important`,
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`,
                    },
                    "& .MuiTabs-indicator": {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    }
                }
            },
            previousIconButton: {
                sx: {
                    "&:disabled": {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    }
                }
            },
            nextIconButton: {
                sx: {
                    "&:disabled": {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    }
                },
            },
            actionBar: {
                sx: {
                    "& .MuiButton-root": {
                        color: `${primaryFontColorSelectorFromConfig} !important`,
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`,
                        border: `1px solid ${primaryFontColorSelectorFromConfig} !important`,
                        ":hover": {
                            backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                            color: `${primaryColorSelectorFromConfig} !important`,
                            border: `1px solid ${primaryFontColorSelectorFromConfig} !important`,
                        }
                    }
                }
            },
            mobilePaper: {
                sx: {
                    '& .MuiClock-pin': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiClockPointer-root': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiClockPointer-thumb': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important` ,
                        borderColor: `${primaryFontColorSelectorFromConfig} !important` ,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiClockPointer-thumb.Mui-selected': {
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`,
                        borderColor: `${primaryColorSelectorFromConfig} !important`,
                        color: `${primaryFontColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersDay-root': {
                        color: `${primaryFontColorSelectorFromConfig} !important`,
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersDay-root.Mui-selected': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersYear-yearButton': {
                        color: `${primaryFontColorSelectorFromConfig} !important` ,
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersYear-yearButton.Mui-selected': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important` ,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    "& .MuiClockNumber-root.Mui-selected": {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    "& .MuiClockNumber-root": {
                        color: `${primaryFontColorSelectorFromConfig} !important`,
                        // backgroundColor: `${primaryColorSelectorFromConfig} !important`
                    }
                }
            },
            desktopPaper: {
                sx: {
                    '& .MuiPickersDay-root': {
                        color: `${primaryFontColorSelectorFromConfig} !important`,
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersDay-root.Mui-selected': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersYear-yearButton': {
                        color: `${primaryFontColorSelectorFromConfig} !important` ,
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersYear-yearButton.Mui-selected': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important` ,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiMultiSectionDigitalClockSection-item.Mui-selected': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                }
            }
        }
    }

    if (props?.field?.properties?.showTime) {
        return (
            <Box key={props?.field._id} sx={{ marginBottom: "16px" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <FormControl fullWidth disabled={props?.field?.properties?.readOnly}>
                        <TimePicker 
                            label={props?.field?.properties?.label} 
                            value={localValue} 
                            onChange={fieldChangeHandle}
                            slotProps={{
                                ...getThemedSlotProps(),
                                desktopPaper: {
                                    sx: {
                                        '& .MuiMultiSectionDigitalClockSection-item': {
                                            color: `${primaryFontColorSelectorFromConfig} !important`,
                                            backgroundColor: `${primaryColorSelectorFromConfig} !important`
                                        },
                                        '& .MuiMultiSectionDigitalClockSection-item.Mui-selected': {
                                            backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                                            color: `${primaryColorSelectorFromConfig} !important`
                                        },
                                    }
                                }
                            }}
                        />
                    </FormControl>
                </LocalizationProvider>
                {!!props?.validationErrors[fieldname] ? <Typography variant="caption" color="error">{props?.validationErrors[fieldname]}</Typography> : null}
            </Box>
        )
    } else {
        return (
            <Box key={props?.field._id} sx={{ marginBottom: "16px" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <FormControl fullWidth disabled={props?.field?.properties?.readOnly}>
                        <DatePicker 
                            value={localValue} 
                            label={props?.field?.properties?.label} 
                            onChange={fieldChangeHandle} 
                            views={props?.field?.properties?.showYear ? ["day", "month", "year"] : ["day", "month"]} 
                            slotProps={{
                                ...getThemedSlotProps(),
                                day: {
                                    sx: {
                                        '&.MuiPickersDay-root': {
                                            color: `${primaryFontColorSelectorFromConfig} !important`,
                                            backgroundColor: `${primaryColorSelectorFromConfig} !important`
                                        },
                                        '&.MuiPickersDay-root.Mui-selected': {
                                            backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                                            color: `${primaryColorSelectorFromConfig} !important`
                                        },
                                    }
                                },
                                desktopPaper: {
                                    sx: {
                                        '& .MuiPickersYear-yearButton': {
                                            color: `${primaryFontColorSelectorFromConfig} !important` ,
                                            backgroundColor: `${primaryColorSelectorFromConfig} !important`
                                        },
                                        '& .MuiPickersYear-yearButton.Mui-selected': {
                                            backgroundColor: `${primaryFontColorSelectorFromConfig} !important` ,
                                            color: `${primaryColorSelectorFromConfig} !important`
                                        },
                                        '&.MuiPaper-elevation8': {
                                            width: '320px !important'
                                        }
                                    }
                                },
                            }}
                        />
                    </FormControl>
                </LocalizationProvider>
                {!!props?.validationErrors[fieldname] ? <Typography variant="caption" color="error">{props?.validationErrors[fieldname]}</Typography> : null}
            </Box>
        )
    }
}

export default NCXFormDate;